import React from 'react'

import { Tooltip, Toolbar } from '@mui/material'
import { PresentToAll as PresentToAllIcon } from '@mui/icons-material'

import { SmallLoadingButton, useIsMobile } from '@edge/spark/ui-mui'

interface Props {
    loading?: boolean
    onShare?: () => void
    open?: boolean
    disabled?: boolean
}

const TOOLTIP_MESSAGE = 'Send selected vehicles to the AMS'

export const SendAmsAction: React.FC<Props> = ({ loading, open, onShare, disabled }: Props) => {
    const isMobileScreenWidth = useIsMobile()
    const buttonText = isMobileScreenWidth ? 'AMS' : 'Send to AMS'
    // Must wrap Tooltip in a div https://github.com/mui-org/material-ui/issues/15663#issuecomment-491498044
    return (
        <Tooltip title={TOOLTIP_MESSAGE}>
            <Toolbar>
                <SmallLoadingButton
                    disabled={disabled}
                    loading={loading || open}
                    onClick={onShare}
                    startIcon={<PresentToAllIcon />}
                >
                    {buttonText}
                </SmallLoadingButton>
            </Toolbar>
        </Tooltip>
    )
}
